<template>
  <div>
    <Header/>
    <CounterUsers/>
    <Checklist/>
    <Statistic/>
    <Infographics/>
    <Together/>
    <Footer/>
    <Thanks/>
  </div>
</template>

<script>
import Header from '@/components/Header';
import Checklist from '@/components/Checklist/Checklist';
import CounterUsers from '@/components/CounterUsers';
import Statistic from '@/components/Statistic.vue';
import Together from '@/components/Together.vue';
import Footer from '@/components/Footer.vue';
import Thanks from '@/components/Thanks.vue';
import Infographics from '@/components/Infographics/Infographics.vue';

export default {
  name: 'Home',
  components: {
    Header,
    Checklist,
    CounterUsers,
    Statistic,
    Together,
    Footer,
    Thanks,
    Infographics
  }
}
</script>
